// Shared modern color palette used across all dashboard charts and tiles.
// Vibrant, harmonized, and accessible on light backgrounds.

export const PALETTE = {
  indigo:  "#6366f1",
  violet:  "#a855f7",
  fuchsia: "#d946ef",
  pink:    "#ec4899",
  rose:    "#f43f5e",
  orange:  "#fb923c",
  amber:   "#f59e0b",
  lime:    "#84cc16",
  emerald: "#10b981",
  teal:    "#14b8a6",
  cyan:    "#06b6d4",
  sky:     "#0ea5e9",
}

// Default cyclical color sequence for unordered categorical data
export const CHART_COLORS = [
  PALETTE.indigo,
  PALETTE.emerald,
  PALETTE.fuchsia,
  PALETTE.amber,
  PALETTE.cyan,
  PALETTE.violet,
  PALETTE.rose,
  PALETTE.teal,
  PALETTE.orange,
  PALETTE.pink,
]

// Semantic colors for project statuses
export const PROJECT_STATUS_COLORS = {
  draft:      "#94a3b8",  // slate-400
  active:     PALETTE.emerald,
  on_hold:    PALETTE.amber,
  reception:  PALETTE.indigo,
  completed:  PALETTE.cyan,
  cancelled:  "#cbd5e1",  // slate-300
}

// Semantic colors for the margin distribution buckets
export const MARGIN_COLORS = {
  "négative": PALETTE.rose,
  "0–10 %":   PALETTE.amber,
  "10–20 %":  PALETTE.lime,
  "20–30 %":  PALETTE.emerald,
  "> 30 %":   PALETTE.teal,
}

// Format a cents number compactly for chart axis labels
export const formatShort = (cents) => {
  const value = cents / 100
  if (Math.abs(value) >= 1_000_000) return `${(value / 1_000_000).toFixed(1)} M€`
  if (Math.abs(value) >= 1_000)     return `${(value / 1_000).toFixed(0)} k€`
  return `${value.toFixed(0)} €`
}

// Shared Nivo theme — light backgrounds, modern type
export const NIVO_THEME = {
  axis: {
    ticks: { text: { fill: "#64748b", fontSize: 10, fontWeight: 500 } },
    legend: { text: { fill: "#475569", fontSize: 11, fontWeight: 600 } },
  },
  grid: { line: { stroke: "#f1f5f9", strokeWidth: 1 } },
  tooltip: {
    container: {
      background: "#0f172a",
      color: "#fff",
      fontSize: 11,
      borderRadius: 6,
      padding: "6px 10px",
      boxShadow: "0 8px 20px rgba(15,23,42,0.25)",
    },
  },
  legends: { text: { fill: "#475569", fontSize: 11 } },
}
